import React from "react"
import PropTypes from "prop-types"

const ArrowCarousel = ({ className }) => {
  return (
    <svg width="15" height="33" viewBox="0 0 15 33" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path fillRule="evenodd" clipRule="evenodd" d="M14.4495 1.17503C14.0979 0.731217 13.6213 0.481934 13.1245 0.481934C12.6276 0.481934 12.151 0.731217 11.7995 1.17503L1.17445 14.6046C0.823327 15.0489 0.626102 15.6513 0.626102 16.2793C0.626102 16.9074 0.823327 17.5097 1.17445 17.9541L11.7995 31.3836C12.1549 31.8023 12.625 32.0302 13.1108 32.0193C13.5965 32.0085 14.06 31.7598 14.4035 31.3256C14.747 30.8913 14.9438 30.3055 14.9524 29.6916C14.961 29.0776 14.7807 28.4834 14.4495 28.0341L5.14945 16.2793L14.4495 4.52452C14.8006 4.08015 14.9978 3.4778 14.9978 2.84977C14.9978 2.22174 14.8006 1.61939 14.4495 1.17503Z" fill="#3F4158"/>
    </svg>

  )
}

ArrowCarousel.propTypes = {
  className: PropTypes.string
}

ArrowCarousel.defaultProps = {
  className: ''
}

export default ArrowCarousel
